// extracted by mini-css-extract-plugin
export default {"root":"BenefitCard__root--adUTm","icon":"BenefitCard__icon--3d4p4","text":"BenefitCard__text--37WDQ"};